<template>
	<div id="content">
		<div class="layout-main">
			<!--main title-->
			<div class="layout-main-wrap">
				<p class="label">主見出しを入力（７〜１０文字）</p>
				<div class="layout-main-title" ref="layoutMainTitle">
					<div class="layout-main-title-wrap" :class="{'layout-main-title-wrap-black': item.background }">
						<input
								type="text"
								maxlength="10"
								id="main-title"
								:value="item.headline"
								:style="{fontSize: headlineFontSize + 'px', transform: headlineTransform}"
								:class="{'isText': item.headline}"
								@input="updateHeadline"
						/>

						<p class="place-holder"
							 :class="{'hidden': item.headline}"
							 v-text="'主見出しを入力（７〜１０文字）'"/>
					</div>
				</div>
			</div>

			<div class="layout-main-title-change"
					 id="changeBackground"
					 @click="changeBackground">背景を変更
			</div>

			<div class="layout-maincontent">
				<div class="layout-maincontent-left">
					<ImageCropper ref="imageCropper"/>

					<!-- Content text 500 -->
					<div class="layout-content-text">
						<div class="layout-content-text-wrap">
							<InputText
									class="layout-content-text-wrap-input"
									:class="{'layout-content-text-wrap-input-bold': item.isLarge }"
									:title="item.content"
									:placeholder="placeholderContent"
									:max-length="624"
									:is-html="true"
									:field-name="'content'"
									id="main-content"
									:character-a-column="16"
							/>
						</div>
					</div>
				</div>

				<!-- Right-->
				<div class="layout-maincontent-right">
					<div class="layout-content-right-wrap-1">
						<div class="layout-subtitle-wrap-1">
							<InputText
									:title="item.article_title"
									:placeholder="`そで見出し②を入力（７〜 <div class='num'>1 0</div>文字）`"
									:max-length="10"
									:field-name="'article_title'"
							/>
						</div>
					</div>

					<div class="layout-content-right-wrap-2">
						<p class="label">袖見出し①を入力（７〜８文字）</p>

						<div class="layout-subtitle-wrap-2">
							<InputText
									:title="item.sleeve_title"
									:placeholder="`そで見出し①を入力（７〜８文字）`"
									:max-length="8"
									:field-name="'sleeve_title'"
									:text-horizontal="false"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<button @click.prevent="selectHTML($event)"
						id="rotate"
						@focus.prevent
						v-if="mainContentFocus === true"
						v-text="'縦中横'"></button>
		<button @click="changeFontSize"
						id="changeFontSize"
						v-text="'文字サイズ変更'"></button>
	</div>
</template>

<script>
	// Components
	import InputText from '../shared/InputText'
	import ImageCropper from '../shared/ImageCropper'

	// mixins
	import KeyHandlingMixin from '../../mixins/keyHandling.mixin'

	// Models
	import NewspaperModel from '../../models/newspaper.model'
	import ErrorModal from '../../models/errors.model'

	export default {
		name: 'FormBody',

		mixins: [
			KeyHandlingMixin
		],

		components: {
			InputText,
			ImageCropper
		},

		data () {
			return {
				mainContentFocus: true,
				tmpData: {},
				isMounted: false,
				placeholderContent: ''
			}
		},

		created () {
			setTimeout(() => {
				this.placeholderContent = `記事を入力（小・最大 <div class='num'>624</div>文字）`
			}, 500)
		},

		mounted () {
			this.isMounted = true
		},

		computed: {
			item () {
				return NewspaperModel.query().find(1) || new NewspaperModel()
			},

			/**
			 * Set fontsize for headline
			 */
			headlineFontSize () {
				if (!this.isMounted) return 154

				const inputLength = this.item.headline.length
				const containerWidth = this.$refs.layoutMainTitle ? this.$refs.layoutMainTitle.offsetWidth : 0
				return containerWidth / inputLength > 154 ? 154 : (containerWidth / inputLength) - 5
			},

			/**
			 * set Headline Transform
			 */
			headlineTransform () {
				const scaleY = this.item.headline.length > 8 ? 1.9 : this.item.headline.length === 0 ? 1 : 1.5

				// return `translate(-50%, -50%) scaleY(${ scaleY })`
				return `scaleY(${ scaleY })`
			}
		},

		methods: {
			/**
			 * Update for HeaderLine
			 */
			updateHeadline (e) {
				this.item.headline = e.target.value

				this.item.$save()
			},

			/**
			 * change background for headline
			 */
			changeBackground () {
				this.item.background = !this.item.background

				this.item.$save()
			},

			changeFontSize () {
				const isNowLarge = this.item.isLarge = !this.item.isLarge
				const wordCount = isNowLarge ? 390 : 624
				const fontSize = isNowLarge ? `大` : `小`
    		this.placeholderContent = `記事を入力（${fontSize}・最大 <div class='num'>${wordCount}</div>文字）`
				this.item.$save()
      }
		}
	}
</script>
